'use strict'

import model from '@/model'
import storage from '@/libs/storage'
import blocklyUtil from '@/blockly/blocklyUtil'

const get = async (uid) => {
  log('currentHandler.list()')
  return await model.current.get(uid)
}

const set = async (_this, project) => {
  log('currentHandler.set()')
  const userInfo = _this.$store.state.userInfo
  const setProject = _this.$store._mutations.setProject[0]
  await model.current.set(userInfo.uid, project)
  setProject(project)
}

const remove = async (_this) => {
  log('currentHandler.remove()')
  const userInfo = _this.$store.state.userInfo
  const setProject = _this.$store._mutations.setProject[0]
  const setBlocklyXml = _this.$store._mutations.setBlocklyXml[0]
  const setIsModified = _this.$store._mutations.setIsModified[0]
  setBlocklyXml('')
  setIsModified(false)
  storage.local.setItem('isModified', false)
  if (userInfo.uid) await model.current.remove(userInfo.uid)
  blocklyUtil.removeWorkspace()
  setProject({})
}

export default {
  get,
  set,
  remove
}
